/// <reference path="../../core/base-data.service.ts" />

namespace app {
	export class LicensePlanService extends DataService<LicensePlan> {

		public resource: string = "license_plans";
	}
	angular.module("app").service("LicensePlanService", LicensePlanService);
}